var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextabstand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 263.14 59.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.86,38.04c3.65,5.24,19.5,12.28,15.81,19.62-2.17,4.32-6.88,1.62-9.63-.19-3.55-2.33-22.46-17.78-24.22-20.46-2.1-3.19-2.51-5.98-.54-9.39C7.29,23.55,25.12.97,30.46.09c1.55-.26,3.15.28,4.39,1.17,3.24,4.6-.16,7.51-3.03,11.14-4.15,5.25-10.29,9.17-14.14,14.75h38.14v10.9H19.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.28,38.04h-35.96v-10.9h38.14c-3.39-5.9-14.53-13.92-17.51-19.02-2.41-4.12.01-8.82,4.73-8.04,5.34.89,23.16,23.47,29.18,27.54,1.97,3.41,1.56,6.2-.54,9.39-1.76,2.67-20.68,18.12-24.22,20.46-2.75,1.81-7.46,4.52-9.63.19-3.69-7.34,12.16-14.39,15.81-19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.82,27.14v10.9h-40.87c-2.99-2.59-1.23-7.31-1.63-10.9h42.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.72,
    y: 27.14,
    width: 33.79,
    height: 10.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.63,
    y: 27.14,
    width: 33.79,
    height: 10.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextabstand);
export default __webpack_public_path__ + "static/media/Textabstand.5254350a8ec8af7c6e55e5a3112df409.svg";
export { ForwardRef as ReactComponent };